import { render, staticRenderFns } from "./FormPart.vue?vue&type=template&id=70f8a08e&"
import script from "./FormPart.vue?vue&type=script&lang=ts&"
export * from "./FormPart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f8a08e')) {
      api.createRecord('70f8a08e', component.options)
    } else {
      api.reload('70f8a08e', component.options)
    }
    module.hot.accept("./FormPart.vue?vue&type=template&id=70f8a08e&", function () {
      api.rerender('70f8a08e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkOrder/FormPart.vue"
export default component.exports